var _defs, _rect, _rect2, _rect3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagSpain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 60,
    viewBox: "0 0 100 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".spainb{fill:#fff;}.spainc{fill:#550c0c;}.spaind{fill:#c39b00;}.spaine{fill:#ad1519;}.spainf{fill:#c60b1e;}.spaing{fill:#283593;}.spainh{fill:#ffc400;}.spaini{fill:#e3e3e3;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "spainf",
    width: 100,
    height: 15.47
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "spainf",
    y: 44.53,
    width: 100,
    height: 15.47
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "spainh",
    y: 15.47,
    width: 100,
    height: 29.06
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "spaini",
    x: 35.59,
    y: 26.51,
    width: 2.28,
    height: 12.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "spainc",
    x: 34.84,
    y: 24.85,
    width: 3.78,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "spainc",
    x: 34.84,
    y: 39.46,
    width: 3.78,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "spainc",
    x: 16.72,
    y: 39.46,
    width: 3.78,
    height: 1.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "spainc",
    x: 16.72,
    y: 24.85,
    width: 3.78,
    height: 1.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "spainf",
    d: "M33.64,23.11l-2.24,2.19v1.21h-7.28v-1.21l-1.87-1.85s.61-1.19,2.45-1.37c0,0,.63-.87,3.08-.63,0,0,2.03-.26,3.11,.66,0,0,2-.05,2.74,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spaind",
    d: "M31.95,24.74l-.55,.55v1.21h-7.28v-1.21l-.42-.42s1.37-.87,4.06-.92c2.69-.03,4.19,.79,4.19,.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spaind",
    d: "M34.1,20.92c-.64-.61-1.37-1.19-2.43-1.03-.15,0-.29,.03-.45,.07-.38-.4-.84-.64-1.33-.67-.45-.04-.96,.05-1.43,.2v-1.04c0-.38-.31-.7-.7-.7s-.7,.31-.7,.7v1.04c-.49-.15-1.01-.23-1.43-.19-.48,.03-.95,.27-1.31,.67-.01,0-.03,0-.05-.01-.09-.02-.17-.05-.3-.05-1.16-.19-1.89,.41-2.52,1.01-.86,.8-.47,1.98-.02,2.66l2.02,1.99v1.6h4.21s.05,.04,.09,.04,.05-.03,.09-.04h4.21v-1.6l2.04-1.99,.11-.13c.35-.57,.71-1.74-.11-2.53Zm-9.58-.58l.2,.21-.2-.09v-.12Zm-2.05,2.42s-.37-.64-.1-.89c.56-.54,.88-.74,1.42-.67l.2,.04c.14,.08,.28,.15,.69,.16,.34-.08,.51-.36,.62-.55,.06-.07,.21-.24,.43-.25,.55-.02,1.14,.13,1.34,.25v5h-2.28v-.83l-2.31-2.26Zm10.64-.05l-2.37,2.32v.83h-2.29v-4.97c.16-.14,.76-.31,1.34-.28,.19,.02,.36,.16,.39,.16h0c.08,.16,.27,.56,.84,.66,.21,0,.36-.09,.5-.18l.23-.04c.54-.07,.86,.13,1.42,.67,.2,.19,.02,.64-.07,.83Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "spainb",
    x: 27.76,
    y: 26.51,
    width: 6.14,
    height: 7.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "spaind",
    d: "M33.91,33.58v2.58c0,2.5-2.03,4.51-4.51,4.51h-1.63v-7.09h6.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spainc",
    d: "M27.76,33.58v7.09h-1.61c-2.5,0-4.51-2-4.51-4.51v-2.58h6.12Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "spaine",
    x: 21.64,
    y: 26.51,
    width: 6.12,
    height: 7.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "spaing",
    cx: 27.76,
    cy: 33.58,
    r: 1.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "spaini",
    x: 17.47,
    y: 26.51,
    width: 2.28,
    height: 12.95
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagSpain);
export default __webpack_public_path__ + "static/media/FlagSpain.f76b92c21f27496298ac418e990cfe91.svg";
export { ForwardRef as ReactComponent };